import { atom, DefaultValue, selector } from "recoil"

interface RoomLinksAtomProps {
  moderatorHash: string
  broadcasterHash: string
  audienceHash: string
}

const roomLinksAtom = atom<RoomLinksAtomProps>({
  key: "roomLinksAtom",
  default: {
    moderatorHash: "",
    broadcasterHash: "",
    audienceHash: ""
  }
})

export const roomLinksSelector = selector({
  key: "roomLinksSelector",
  get: ({ get }) => {
    return get(roomLinksAtom)
  },
  set: ({ set }, roomLinks: RoomLinksAtomProps | DefaultValue) => {
    set(roomLinksAtom, roomLinks)
  }
})
